import { useQuery } from "react-query";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { ObjectTagValuesAvailableItem } from "../../services/object-tag-values-data-service/ConfigurationModels";
import ObjectTagValuesDataService from "../../services/object-tag-values-data-service/ObjectTagValuesDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseObjectTagValuesAvailableItemsQueryParameters = {
    groupID: number;
    objectType: eLynxObjectTypeEnum,
    objectID: number,
} & BaseUseQueryParameters<Array<ObjectTagValuesAvailableItem>>;

export function useObjectTagValuesAvailableItems({
    groupID,
    objectType,
    objectID,
    enabled,
    onError,
    onSuccess
}: UseObjectTagValuesAvailableItemsQueryParameters) {
    return useQuery<Array<ObjectTagValuesAvailableItem> | undefined, RestError>(
        keys.availableItemList(
            groupID,
            objectType,
            objectID
        ),
        ({ signal }) => {
            return ObjectTagValuesDataService.getAvailableItems(
                groupID,
                objectType,
                objectID,
                signal
            );
        },
        {
            enabled: enabled,
            onError: onError,
            onSuccess: onSuccess,
        }
    );
}